import { FiHome, FiUsers } from 'react-icons/fi';
import { ILinkItemProps } from '../SidebarItem';

export const TeacherSidebarLinkItems: Array<ILinkItemProps> = [
  { name: 'Home', icon: FiHome, link: '/teacher' },
  {
    name: 'Student Analytics',
    icon: FiUsers,
    link: '/teacher/student-analytics',
  },
];
